import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';
import { DropEvent, FileRejection, useDropzone } from 'react-dropzone';
import { AutoDetectSourceLanguagesOpenRangeOptionName } from 'microsoft-cognitiveservices-speech-sdk/distrib/lib/src/common.speech/Exports';
import { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Chip from '@mui/material/Chip';
import ReadExcel from '../ImportExcelReader';

const UploadComponent = ({ text, handleFunc, requiredColumns, contentChange }: { text: string, handleFunc?: (excel:(string)[][])=>void , requiredColumns?: string[], contentChange? : (file:File|null)=> void}) => {

  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [showError, setshowError] = useState<string | null>(null);

  const onDrop = (acceptedFiles: File[]) => {
    if (acceptedFiles.length > 0) {
      setUploadedFile(acceptedFiles[0]);
      ReadExcel(acceptedFiles[0], requiredColumns).then(result => {
        setLoading(false);
        if (result.error) {
          setshowError(`could not upload file: ${result.error.message}.`)
        }
        else {
          if(handleFunc){
            handleFunc(result.data);
          }
          setshowError(null);
        }
      });
      setLoading(true);
      setshowError(null);
    }
    else {
      setUploadedFile(null);
    }
  };

  useEffect(() => {
    if(contentChange)
    {
      contentChange(uploadedFile);
    }
}, [uploadedFile]);

  const handleFileRemove = () => {
    setUploadedFile(null);
    setshowError(null);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
    },
    onError: (err: Error) => setshowError('could not upload file'),
    onDropRejected: (fileRejections: FileRejection[], event: DropEvent) => setshowError('could not upload file'),
    maxFiles: 1
  }); // Only accept one file}); // Accept Excel files });

  return (
    <Box
      {...getRootProps()}
      sx={{
        cursor: 'pointer',
        display: 'flex',           // Flexbox for centering
        flexDirection: 'column',
        border: '2px dashed #2a2e5a', // Dashed border
        justifyContent: 'center',  // Horizontally center content
        alignItems: 'center',      // Vertically center content
        width: '60%',            // Set width  
        padding: '1.5rem',
        borderRadius: '8px',       // Optional rounded corners
        margin: '16px',            // Spacing around the rectangle
      }}
    >
      <input {...getInputProps()} />
      <AddIcon
        sx={{ fontSize: '48px', color: '#2a2e5a' }} // Plus icon styling
      />
      <Typography
        variant="body2"
        sx={{ color: 'rgba(0, 0, 0, 0.6)', marginTop: '1rem' }} // Text style
      >
        {text}
      </Typography>
      {loading ? (
        <Box sx={{ mt: 2 }}>
          <CircularProgress />
          <Typography variant="body2" color="textSecondary">
            Uploading...
          </Typography>
        </Box>
      ) : <>{
        uploadedFile && (
          <Chip
            label={uploadedFile.name}
            onDelete={handleFileRemove}
            deleteIcon={<CancelIcon />}
            color="primary"
            style={{ marginTop: '0.5rem' }}
          />
        )
      }

        {showError && <Box sx={{ mt: 2, color: 'red', textAlign: 'left' }}>
          <Typography variant="subtitle1" gutterBottom>
            {showError}
          </Typography>
        </Box>
        }
      </>
      }

    </Box>
  );
};

export default UploadComponent;